import { useState } from "react";
import { HiArrowLeft, HiBookmark, HiLogout } from "react-icons/hi";
import "../../styles/CourseStructure.css";
import { BookmarkAnnotationPanel } from "../features";

const CourseStructure = ({
  topics,
  activeTopicId,
  onSelectTopic,
  courseData,
  onNavigateToPage,
  onPanelClose,
  syncCallback,
  onLogout,
  onBackToCourses,
}) => {
  const [showBookmarksPanel, setShowBookmarksPanel] = useState(false);

  // Debug: Log the topics to see what's happening
  console.log('CourseStructure topics:', topics);
  console.log('ActiveTopicId:', activeTopicId);

  return (
    <>
      <aside className="course-structure-sidebar">
        <div className="course-structure-brand">
          <img
            src="/images/Somayya-Academy-Logo-for-Website-Home.001.png"
            alt="Somayya Academy"
          />
        </div>

        <div className="course-structure-content">
          <button
            type="button"
            className="back-to-courses-btn"
            onClick={onBackToCourses}
          >
            <HiArrowLeft aria-hidden="true" />
            <span>Back to All Courses</span>
          </button>

          <div className="course-content">
            <div className="course-header">
              <span className="course-section-label">Course</span>
              <h2 className="course-title">{courseData?.title || "Course"}</h2>
            </div>

            <div className="topics-list">
              <h3 className="topics-section-title">Topics</h3>
              <ul className="topics-container">
                {topics
                  .filter(topic => {
                    // More lenient filtering - show topics that are purchased OR if courseData indicates it's purchased
                    const isPurchased = topic.isPurchase === true ||
                      courseData?.isPurchase === true ||
                      topic.isPurchase === 1 ||
                      topic.isPurchase === "true";

                    console.log(`Topic ${topic.id} (${topic.title}): isPurchase=${topic.isPurchase}, isPurchased=${isPurchased}`);

                    return isPurchased;
                  })
                  .sort((a, b) => {
                    // Sort by orderIndex if available, otherwise maintain original order
                    const orderA = a.orderIndex !== undefined ? a.orderIndex : a.id;
                    const orderB = b.orderIndex !== undefined ? b.orderIndex : b.id;
                    return orderA - orderB;
                  })
                  .map(topic => (
                    <li
                      key={topic.id}
                      className={`topic-item ${topic.id === activeTopicId ? "active" : ""}`}
                      onClick={() => onSelectTopic(topic.id)}
                    >
                      <div className="topic-content">
                        <span className="topic-title">{topic.title}</span>
                      </div>
                      {topic.originalStructure && topic.id === activeTopicId && (
                        <span className="page-indicator">
                          ({(topic.currentPageIndex || 0) + 1} of{" "}
                          {topic.originalStructure.totalPages})
                        </span>
                      )}
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="course-structure-actions">
          <button type="button" className="bookmarks-btn" onClick={() => setShowBookmarksPanel(true)}>
            <HiBookmark aria-hidden="true" />
            <span>Bookmarks and annotations</span>
          </button>
        </div>

        <div className="course-structure-logout">
          <button type="button" className="course-logout-btn" onClick={onLogout}>
            <HiLogout aria-hidden="true" />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Bookmarks & Annotations Panel */}
      {showBookmarksPanel && (
        <BookmarkAnnotationPanel
          onNavigateToPage={onNavigateToPage}
          onClose={() => {
            setShowBookmarksPanel(false);
            if (onPanelClose && syncCallback) {
              onPanelClose(syncCallback);
            }
          }}
          topics={topics}
          courseData={courseData}
          onSyncHighlights={syncCallback}
        />
      )}
    </>
  );
};

export default CourseStructure;